import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { useAccount } from './AccountContext';
import TransactionRow from './TransactionRow';
import { brand } from '../theme';
import SurfaceCard, { CardHeader } from '../ui/SurfaceCard';

/** Activity list — deposits, withdrawals and reversals, newest first. */
export default function AccountPanel() {
  const { account, loading, waitingForDeposit } = useAccount();
  const transactions = account?.transactions ?? [];

  return (
    <SurfaceCard data-testid="activity-card">
      <CardHeader title="Activity" />

      {loading && !account ? (
        <Stack alignItems="center" py={4}>
          <CircularProgress size={28} />
        </Stack>
      ) : transactions.length === 0 ? (
        <Stack
          alignItems="center"
          spacing={1.5}
          sx={{ textAlign: 'center', py: 4.5, px: 1 }}
        >
          <Box
            component="span"
            aria-hidden
            sx={{
              width: 52,
              height: 52,
              borderRadius: '16px',
              backgroundColor: brand.goldWash,
              color: brand.goldDeep,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 22,
              fontWeight: 800,
            }}
          >
            ↓
          </Box>
          <Typography sx={{ fontSize: 17, fontWeight: 700 }}>No activity yet</Typography>
          <Typography
            sx={{
              fontSize: 13.5,
              color: brand.faint,
              lineHeight: 1.55,
              maxWidth: 260,
              textWrap: 'pretty',
            }}
          >
            Deposits and withdrawals will appear here. Use Deposit to get an address,
            then send funds.
          </Typography>
        </Stack>
      ) : (
        <Box sx={{ mt: 0.5 }}>
          {transactions.map((tx) => (
            <TransactionRow key={tx.id} tx={tx} />
          ))}
        </Box>
      )}

      {waitingForDeposit && transactions.length > 0 ? (
        <Typography
          sx={{
            mt: 2,
            fontSize: 12.5,
            fontWeight: 600,
            color: brand.goldDeep,
            animation: 'chd-pulse 2.2s ease-in-out infinite',
          }}
        >
          Waiting for your deposit…
        </Typography>
      ) : null}
    </SurfaceCard>
  );
}
